export const VISIT_PURPOSE_OPTIONS = [
  'Day Visit',
  'Overnight Visit',
  'Volunteer',
  'Program - Additional Days Stay',
  'Program - Lodging Upgrade',
  'Sadhana (General)',
  'Training',
  'Volunteer in Lieu for Program',
  'Free Yoga Day',
  'Other (Please specify in the Notes)',
  'Adi yogi volunteering',
  'Isha Fest Volunteering',
  'Special Event',
  'Yantra Ceremony',
  'Day Volunteer',
  'long term volunteer'
]

export const HOW_DID_YOU_HEAR_OPTIONS = [
  'From a friend or family member',
  'From a colleague',
  'Watched a YouTube video',
  'Facebook',
  'Magazine',
  'Saw something online',
  'At an event',
  'Other'
]

export const WHAT_MOTIVATED_YOUR_VISIT_OPTIONS = [
  'Joining family / friend who wanted to visit',
  'To learn yoga / take a program',
  'To hike, bike or explore the property',
  'To visit the Abode of Yoga',
  'Wanted to get away for a few days / retreat',
  'Special occasion (birthday, anniversary) or auspicious day',
  'Free Yoga Day',
  'Other'
]



// WEBPACK FOOTER //
// ./src/components/dropdownOptions.js